import { Switch, Route, Router as WouterRouter, useLocation } from "wouter";
import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import Book from "@/pages/book";
import Membership from "@/pages/membership";
import Join from "@/pages/join";
import Actuarial from "@/pages/actuarial";
import Survey from "@/pages/survey";
import FurGenomics from "@/pages/furgenomics";
import Journal from "@/pages/journal";
import Press from "@/pages/press";

const queryClient = new QueryClient();

function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location]);
  return null;
}

function Router() {
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/book" component={Book} />
        <Route path="/membership" component={Membership} />
        <Route path="/join/:tier" component={Join} />
        <Route path="/actuarial" component={Actuarial} />
        <Route path="/survey" component={Survey} />
        <Route path="/furgenomics" component={FurGenomics} />
        <Route path="/journal" component={Journal} />
        <Route path="/press" component={Press} />
        <Route component={NotFound} />
      </Switch>
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, "")}>
          <Router />
        </WouterRouter>
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
